import fetch from "api/utils/enhancedFetch";
import { getProxycadorHost } from "environment";

// this endpoint is used to update to cookies, response payload is ignored
// response payload type is described below (used in previous versions)

export interface VideoTokenData {
  expireAt: number;
  token: string;
  ttlSeconds: number;
  username: string;
}

const REQUEST_TIMEOUT_MILLISECONDS = 2000;

const requestTimeoutMilliseconds =
  // eslint-disable-next-line compat/compat
  AbortSignal.timeout ??
  ((milliseconds: number) => {
    const ctrl = new AbortController();
    setTimeout(() => ctrl.abort(), milliseconds);

    return ctrl.signal;
  });

export const fetchVideoToken = (): Promise<VideoTokenData> =>
  fetch(
    `${getProxycadorHost()}/proxycador/api/public/v1/live/stream/v1/tokenData`,
    { signal: requestTimeoutMilliseconds(REQUEST_TIMEOUT_MILLISECONDS) }
  ).then((resp) => resp.json());
